export default __webpack_public_path__ + "static/media/circle1Hsb.ccfa27b9.svg";